import { ChartFrequency, IComposableChartsWidget, IMappingsAnalyticsPayload } from 'wisestep-api';

import MappingBarChartPostgre from '../../../BaseCharts/mappings/new/MappingBarChartPostgre';
import MappingsMetricPostgre from '../../../BaseCharts/mappings/new/MappingsMetricPostgre';
import MappingsTablePostgre from '../../../BaseCharts/mappings/new/MappingsTablePostgre';
import { ChartScope } from '../../../types';
import { ApplicationWidget, getChartFreqForTimePeriod, MappingsWidget } from '../../helper';
import { jobsTimePeriodList } from '../../Jobs/helper';

const applicationWidgetByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Partial<Record<ApplicationWidget, IComposableChartsWidget>> => {
  const defaultQuery: IMappingsAnalyticsPayload = {
    category: 'application',
    filters: [],
    type: 'MAPPING_COUNT',
    candidateStatusTags: ['applied'],
    range: timePeriodId,
    scope,
    frequency,
  };
  const freqInRegularCase = frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase();

  const widgetConfig = {
    [ApplicationWidget.METRIC_TOTAL]: {
      name: 'Total Application Received',
      filters: {},
      category: 'application',
      type: `metric_app_${timePeriodId}_${scope}_postgre`,
      component: (
        <MappingsMetricPostgre
          query={{
            ...defaultQuery,
            type: 'MAPPING_COUNT',
          }}
          title="Application Received"
          widgetName={MappingsWidget.MAPPING_COUNT}
        />
      ),
    },
    [ApplicationWidget.METRIC_SOURCE]: {
      name: 'Application Received - Source',
      filters: {},
      category: 'application',
      type: `metric_app_source_${timePeriodId}_${scope}_postgre`,
      component: (
        <MappingsMetricPostgre
          query={{
            ...defaultQuery,
            type: 'SOURCE',
          }}
          title="Application Received Source"
          widgetName={MappingsWidget.MAPPING_COUNT}
        />
      ),
    },
    [ApplicationWidget.TABLE_JOB_TITLE]: {
      name: 'Application Received - Job Title',
      filters: {},
      category: 'application',
      type: `table_app_jobtitle_${timePeriodId}_${scope}_postgre`,
      component: (
        <MappingsTablePostgre
          query={{ ...defaultQuery, type: 'TABLE_APPLICATION_JOB_TITLE' }}
          title="Application Received Job Title"
          widgetName={MappingsWidget.TABLE_JOB_TITLE}
          widgetType={`table_app_jobtitle_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [ApplicationWidget.TABLE_JOB_BOARD]: {
      name: 'Application Received - Job Boards',
      filters: {},
      category: 'application',
      type: `table_app_jobboard_${timePeriodId}_${scope}_postgre`,
      component: (
        <MappingsTablePostgre
          query={{ ...defaultQuery, type: 'TABLE_RECRUITER_JOB_BOARD' }}
          title="Application Received Job Boards"
          widgetName={MappingsWidget.TABLE_JOB_BOARD}
          widgetType={`table_app_jobboard_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [ApplicationWidget.TABLE_JOB_SOURCE]: {
      name: 'Application Received - Source',
      filters: {},
      category: 'application',
      type: `table_app_jobsource_${timePeriodId}_${scope}_postgre`,
      component: (
        <MappingsTablePostgre
          query={{ ...defaultQuery, type: 'SOURCE' }}
          title="Application Received Source"
          widgetName={MappingsWidget.TABLE_JOB_SOURCE}
          widgetType={`table_app_jobsource_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [ApplicationWidget.BAR_CHART]: {
      name: `Total Application Received - ${freqInRegularCase}`,
      filters: {},
      category: 'application',
      type: `barchart_app_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <MappingBarChartPostgre
          query={{ ...defaultQuery, type: 'APPLICATION_TREND' }}
          title={`Application Received ${freqInRegularCase}`}
        />
      ),
    },
  };

  return widgetConfig;
};

export const applicationWidgetKeyPostgre = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgetList = Object.values(applicationWidgetByTimeAndScope(timePeriodId, scope));
  const extraWidgetList = {};

  return [...defaultWidgetList, ...(extraWidgetList[timePeriodId] ?? [])];
};

export const postgreApplicationDashboardKeysObjectList = jobsTimePeriodList.flatMap(
  (timePeriod) => [
    ...applicationWidgetKeyPostgre(timePeriod.id, ChartScope.WORKSPACE),
    ...applicationWidgetKeyPostgre(timePeriod.id, ChartScope.LOGGED_IN_USER),
    ...applicationWidgetKeyPostgre(timePeriod.id, ChartScope.TEAMS),
  ]
);
